<template lang="pug">
  .exchange-goods-skeleton-container
    SkeletonItem(className='exchange-goods-skeleton-title')
    .exchange-goods-skeleton-list
      SkeletonItem(className='exchange-goods-skeleton-list-item')
      SkeletonItem(className='exchange-goods-skeleton-list-item')
      SkeletonItem(className='exchange-goods-skeleton-list-item')
      SkeletonItem(className='exchange-goods-skeleton-list-item')
    SkeletonItem(className='exchange-goods-skeleton-progress')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'ExchangeGoodsSkeleton',
  components: {
    SkeletonItem,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.exchange-goods-skeleton-container {
  padding: 0.16rem 0.12rem 0.12rem;
  width: 100%;
  background-image:
    linear-gradient(
      174.59deg,
      #ddf1ff 4.13%,
      #fff 21.31%,
      #fff 95.68%
    );
  border-radius: 0.16rem;
  border: 0.01rem solid #fff;
  box-sizing: border-box;

  .exchange-goods-skeleton-title {
    width: 1.38rem;
    height: 0.24rem;
  }

  .exchange-goods-skeleton-list {
    display: flex;
    justify-content: space-between;
    margin-top: 0.15rem;
  }

  .exchange-goods-skeleton-list-item {
    width: 0.78rem;
    height: 0.56rem;
  }

  .exchange-goods-skeleton-progress {
    margin-top: 0.12rem;
    width: 100%;
    height: 0.27rem;
  }
}
</style>
